<template>
  <div class="post-view">
    <template v-if="loaded && post">
      <header>
        <h3>
          {{ post.title }}
        </h3>

        <align small-gap>
          <icon-button
            v-if="isStaff"
            icon="edit"
            @click="edit"
          />

          <icon-button
            tooltip="Close card"
            icon="close"
            @click="close"
          />
        </align>
      </header>

      <div class="post-content">
        <div class="subtitle">
          <div>Posted {{ $filters.datetime(post.date) }}</div>
          <div v-if="post.creator">
            {{ post.creator }}
          </div>
        </div>

        <p v-if="post.image" class="image">
          <img :src="post.image" />
        </p>

        <section class="body">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <p v-html="post.body" />

          <section
            v-if="post.cardNotes && post.cardNotes.length > 0"
            class="card-notes"
          >
            <template v-if="post.category === 'Headline'">
              <card-note
                v-for="(cardNote, i) in post.cardNotes"
                :key="i"
                as="router-link"
                :to="`/card/${cardNote.card}`"
                target="_blank"
                :card-note="cardNote"
              />
            </template>

            <template v-else>
              <card-list-item
                v-for="(cardNote, i) in post.cardNotes"
                :key="i"
                as="router-link"
                target="_blank"
                :to="`/card/${cardNote.card}`"
                :card="cardNote"
              />
            </template>
          </section>
        </section>
      </div>
    </template>

    <spinner v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as Sentry from '@sentry/vue';

import { feedService } from '@/services';
import CardListItem from '@cardladder/shared/components/CardListItem';
import CardNote from '@cardladder/shared/components/CardNote';

export default {
  components: {
    CardNote,
    CardListItem,
  },

  props: {
    id: String,
  },

  data() {
    return {
      post: {},
      title: '',
      loaded: false,
    };
  },

  created() {
    this.load();
  },

  watch: {
    id(to, from) {
      if (to !== from) {
        this.load();
      }
    },
  },

  computed: {
    ...mapGetters({
      isStaff: 'isStaff',
    }),
  },

  methods: {
    async load() {
      this.loaded = false;

      try {
        this.post = await feedService.getPost(this.id);
        this.title = this.post?.title || '';
      } catch (e) {
        this.$toasted.error('Error loading the post');
        Sentry.captureException(e);
      }

      this.loaded = true;
    },

    close() {
      const query = { ...this.$router.query };
      delete query.postId;
      this.$router.push({ query });
    },

    edit() {
      this.$bus.$emit('admin-edit-post', this.post.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.post-view {
  padding: $gp;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  h2 {
    flex: 1;
    margin-right: $gp;
    margin-bottom: 0;
  }
}

.subtitle {
  font-size: 14px;
  color: $color-gray-5;
  margin-bottom: $gp;
}

.body {
  font-size: 18px;
  line-height: 1.5;
}

.image {
  img {
    object-fit: cover;
    max-width: 100%;
    max-height: 200px;
  }
}

.card-notes {
  margin-top: $gp;
}
</style>
